import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { METHODOLOGY_EXPLAINER_PAGE_NCI } from '@/config/constants';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const RestorationLandMonitoringExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='restoration-project-explainer'>{t('global.howDoWeMeasureThis')}</ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{t('global.howDoWeMeasureThis')}</ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy
              title={t(
                'shared.ncaDetail.ecologicalIntegrity.historicalDataBU.explainers.howDoWeMeasure.habitatIntactness.title',
              )}
              body={
                <span className='whitespace-pre-wrap'>
                  {t(
                    'shared.ncaDetail.ecologicalIntegrity.historicalDataBU.explainers.howDoWeMeasure.habitatIntactness.body',
                  )}
                </span>
              }
            />
            <ExplainerCopy
              title={t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.waterHoldingTitle')}
              body={t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.waterHoldingBody')}
            />
            <ExplainerCopy
              title={t('shared.ncaDetail.details.aboveGroundCarbon.labels.aboveGroundCarbon')}
              body={`${t('shared.ncaDetail.details.aboveGroundCarbon.explainers.howDoMeasureThis.carbonAboveGroundBody')}\n${t('shared.ncaDetail.details.aboveGroundCarbon.explainers.howDoMeasureThis.carbonAboveGroundBody2')}`}
            />
            <ExplainerCopy
              title={t('shared.ncaDetail.details.landMonitoring.ndvi.explainers.howDoWeMeasureThis.title')}
              body={t('shared.ncaDetail.details.landMonitoring.ndvi.explainers.howDoWeMeasureThis.body')}
            />
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_EXPLAINER_PAGE_NCI} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
